/*!
 * @utiljs/string 0.6.3 (http://git.sankuai.com/projects/WM/repos/utiljs/browse/packages/string/)
 * API http://git.sankuai.com/projects/WM/repos/utiljs/browse/packages/string/doc/api.md
 * Copyright 2017-2019 美团mfe. All Rights Reserved
 * Licensed under MIT (http://git.sankuai.com/projects/WM/repos/utiljs/browse/packages/string/LICENSE)
 */

import { type } from '@utiljs/type';
import { error } from '@utiljs/console';

function encodeHTML(str) {
  if (typeof str === 'undefined') {
    error('@utiljs/string#encodeHTML param must is string');
    return '';
  }

  return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/\\/g, '&#92;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
}
function decodeHTML(str) {
  if (typeof str === 'undefined') {
    error('@utiljs/string#decodeHTML param must is string');
    return '';
  }

  return String(str).replace(/&amp;/g, '&').replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&#92;/g, '\\').replace(/&quot;/g, '"').replace(/&#39;/g, "'");
}
function trimAllSpace(str) {
  if (typeof str === 'undefined') {
    error('@utiljs/string#trimAllSpace param must is string');
    return '';
  }

  str = String(str);
  return str.replace(/\s/g, '');
}
function truncate(str, len) {
  var omission = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '...';

  if (typeof str === 'undefined') {
    error('@utiljs/string#truncate first param must is string');
    return '';
  }

  str = String(str);
  omission = String(omission);
  len = Math.round(len);

  if (isNaN(len)) {
    error('@utiljs/string#truncate second param must is string');
    return '';
  }

  if (str.length > len) {
    str = str.slice(0, len - omission.length) + omission;
  }

  return str;
}
function leftpad(str) {
  var len = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  var char = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '0';

  if (typeof str === 'undefined') {
    error('@utiljs/string#leftpad first param must is string');
    return '';
  }

  str = String(str);
  len = Math.round(len);
  len = isNaN(len) ? 2 : len;
  char = String(char);
  var i = len - str.length;

  while (i--) {
    str = char + str;
  }

  return str;
}
function snakeCase(str) {
  if (typeof str === 'undefined') {
    error('@utiljs/string#snakeCase first param must is string');
    return '';
  }

  return String(str).replace(/[-.,\s]+/g, '_').replace(/[A-Z]/g, function (matches) {
    return "_".concat(matches.toLowerCase());
  }).replace(/[_]+/g, '_');
}
function camelCase(str) {
  var lower = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  if (typeof str === 'undefined') {
    error('@utiljs/string#camelCase first param must is string');
    return '';
  }

  str = String(str);
  lower = !!lower;

  if (lower) {
    return str.replace(/[-_.,\s]+(\w)/gi, function (matches, letter) {
      return letter.toUpperCase();
    });
  } else {
    return str.replace(/^\S/, function (s) {
      return s.toUpperCase();
    }).replace(/[-_.,\s]+(\w)/gi, function (matches, letter) {
      return letter.toUpperCase();
    });
  }
}
function camelCaseKey(obj) {
  var _this = this;

  var lower = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  if (type(obj) !== 'object') {
    error('@utiljs/string#camelCaseKey first param must is object');
    return null;
  }

  lower = !!lower;
  var ret = {};
  Object.keys(obj).forEach(function (key) {
    ret[_this.camelCase(key, lower)] = obj[key];
  });
  return ret;
}
function snakeCaseKey(obj) {
  var _this2 = this;

  if (type(obj) !== 'object') {
    error('@utiljs/string#snakeCaseKey first param must is object');
    return null;
  }

  var ret = {};
  Object.keys(obj).forEach(function (key) {
    ret[_this2.snakeCase(key)] = obj[key];
  });
  return ret;
}

var formatter = function formatter(value, num) {
  return value.toFixed(num);
};

function format1024(y) {
  var num = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var value = Number(y);

  if (isNaN(value)) {
    error('@utiljs/string#format1024 first param must is number');
    return '';
  }

  num = Math.round(num);

  if (isNaN(num) || num < 0) {
    num = 0;
  }

  value = Math.abs(value);

  if (value >= 1125899906842624) {
    return formatter(value / 1125899906842624, num) + 'P';
  } else if (value >= 1099511627776) {
    return formatter(value / 1099511627776, num) + 'T';
  } else if (value >= 1073741824) {
    return formatter(value / 1073741824, num) + 'G';
  } else if (value >= 1048576) {
    return formatter(value / 1048576, num) + 'M';
  } else if (value >= 1024) {
    return formatter(value / 1024, num) + 'K';
  } else if (value < 1 && value > 0) {
    return formatter(value, num);
  } else if (value === 0) {
    return 0;
  } else {
    return formatter(value, num);
  }
} // 将传入的数字用千万符分隔

function formatThousands(num) {
  if (isNaN(Number(num))) {
    error('@utiljs/string#formatThousands first param must is number');
    return '';
  }

  num = String(num);
  var splitNum = num.split('.'); // 整数部分

  var integer = splitNum[0]; // 小数部分

  var decimal = splitNum[1] || '';
  var result = '';

  while (integer.length > 3) {
    result = ",".concat(integer.slice(-3)).concat(result);
    integer = integer.slice(0, integer.length - 3);
  }

  if (integer) {
    result = "".concat(integer).concat(result);
  }

  if (decimal === '') {
    return result;
  }

  return "".concat(result, ".").concat(decimal);
}

export { encodeHTML, decodeHTML, trimAllSpace, truncate, leftpad, snakeCase, camelCase, camelCaseKey, snakeCaseKey, format1024, formatThousands };
